<template>
    <div>
        <div class="body-overlay" id="body-overlay"></div>
        <SearchPopup />
        <Header2 />
        <div class="error-area pd-bottom-120 bg-relative text-center">
            <img class="left_image_bounce position-bottom-left" :src="require('@/assets/img/about/7.png')" alt="img">
            <img class="left_image_bounce position-center-right" :src="require('@/assets/img/about/9.png')" alt="img">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-7">
                        <h2>404</h2>
                        <h3>Lo sentimos, la pagina que estas bucando no se encuentra disponible!.</h3>
                        <a class="btn btn-black border-radius" href="javascript:void(0)">Back To Homepage</a>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
    import SearchPopup from '@/components/layout/SearchPopup.vue'
    import Header2 from '@/components/layout/Header2.vue'
    import Footer from '@/components/layout/Footer.vue'

    export default {
        name: "Pricing",
        components: {
            SearchPopup,
            Header2,
            Footer
        },
    }
</script>


// WEBPACK FOOTER //
// src/pages/Error.vue